import PropTypes from 'prop-types';

// cherry-pick lodash methods (the right way). DO NOT use import from 'lodash'.
import values from 'lodash/values';

import { ModalButtonActionType } from './ModalButtonActionType.enum';

export const ModalButtonShape = PropTypes.shape({
	type: PropTypes.oneOf(values(ModalButtonActionType)),
	text: PropTypes.string,
	onClick: PropTypes.func,
});
